import { SetupAttributeType } from "../types";
import {
  personaPrimaryAttributesSetup,
  personaSecondaryAttributesSetup,
  prepare,
} from "./config";
import type { PersonaAttributes } from "./types";

export const PersonaProvider = {
  init() {
    function trySetup(
      arrayItem: SetupAttributeType<PersonaAttributes>[number],
    ) {
      try {
        arrayItem.setup();
      } catch {
        console.log("FAILED TO SETUP ", arrayItem.id);
      }
    }

    prepare();

    personaPrimaryAttributesSetup.forEach(trySetup);
    console.log("SETUP PERSONA PRIMARY ATTRIBUTES");
    personaSecondaryAttributesSetup.forEach(trySetup);
  },
};
